export default "<app-navbar></app-navbar>\r\n<router-outlet></router-outlet>"